module.exports = __webpack_public_path__ + "static/img/g_legs.516d5f04.webp";